import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { ReactComponent as CheckIcon } from 'images/icons/check-grey.svg'
import { ReactComponent as PlusIcon } from 'images/icons/plus-icon.svg'
import ProgressBar from '../ProgressBar.component'
import { useUploadButtonsService } from './UploadButtons.service'

const UploadButtons = (props) => {
  const { 
    feedButtonFilled, 
    reelButtonFilled, 
    feedButtonDisabled, 
    reelButtonDisabled, 
    showFeedProgress, 
    showReelProgress, 
    progress, 
    readonly,
    handleFileSelect,
    fileId,
    feedFileId,
    reelFileId
  } = props
  
  const { handleButtonClick, onFileInputChange, fileInputRef } = useUploadButtonsService({ feedButtonFilled, reelButtonFilled, feedFileId, reelFileId, fileId, handleFileSelect })
  
  // return
  return (
    <div className="accepted-file__add-media-buttons">
      <input
        ref={fileInputRef}
        type="file"
        accept="image/jpeg, image/png, video/*"
        onChange={onFileInputChange}
        style={{ display: 'none' }}
      />
      
      {showFeedProgress ? (
        <div className="accepted-file__progress-container">
          <ProgressBar progress={progress} />
        </div>
      ) : (
        <button 
          onClick={(e) => handleButtonClick(e, 'feed')} 
          className={classnames('accepted-file__add-media-button', {
            'accepted-file__add-media-button__empty': !feedButtonFilled,
            'accepted-file__add-media-button__disabled': feedButtonDisabled || readonly,
          })}
          disabled={feedButtonDisabled || readonly}
        >
          {feedButtonFilled ? (
            <span className="accepted-file__add-media-button__check-icon"><CheckIcon width={14} height={14} /></span>
          ) : (
            <span className="accepted-file__add-media-button__plus-icon"><PlusIcon width={8} height={8} /></span>
          )}

          <span>Feed</span>
        </button>
      )}

      {showReelProgress ? (
        <div className="accepted-file__progress-container">
          <ProgressBar progress={progress} />
        </div>
      ) : (
        <button 
          onClick={(e) => handleButtonClick(e, 'reel')} 
          className={classnames('accepted-file__add-media-button', {
            'accepted-file__add-media-button__empty': !reelButtonFilled,
            'accepted-file__add-media-button__disabled': reelButtonDisabled || readonly,
          })}
          disabled={reelButtonDisabled || readonly}
        >
          {reelButtonFilled ? (
            <span className="accepted-file__add-media-button__check-icon"><CheckIcon width={14} height={14} /></span>
          ) : (
            <span className="accepted-file__add-media-button__plus-icon"><PlusIcon width={8} height={8} /></span>
          )}

          <span>Reel</span>
        </button>
      )}
    </div>
  )
}

export default UploadButtons

UploadButtons.propTypes = {
  feedButtonFilled: PropTypes.bool.isRequired,
  reelButtonFilled: PropTypes.bool.isRequired,
  handleFileSelect: PropTypes.func.isRequired,
  fileId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  feedFileId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  reelFileId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  feedButtonDisabled: PropTypes.bool,
  reelButtonDisabled: PropTypes.bool,
  showFeedProgress: PropTypes.bool,
  showReelProgress: PropTypes.bool,
  progress: PropTypes.number,
  readonly: PropTypes.bool,
}